import { css } from "@emotion/react"

import { fontFaces } from "./fonts"

import { iqAccordion } from "./components/accordion"
import { iqBtn } from "./components/button"
import { iqCard } from "./components/card"
import { iqCentralizedModal } from "./components/centralizedModal"
import { iqForm } from "./components/form"
import { iqHeader } from "./components/header"
import { iqText } from "./components/text"
import { iqTooltip } from "./components/tooltip"

export const blueberry = css`
${fontFaces}
${iqAccordion}
${iqBtn}
${iqCard}
${iqCentralizedModal}
${iqForm}
${iqHeader}
${iqTooltip}
${iqText}
`
